// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__waQWT","paramInput":"JobSimulator_paramInput__291hq","input":"JobSimulator_input__1euzi"};